<template>
  <a-card :bordered="false">
    <div>
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :md="6" :sm="12">
              <a-form-item label="选择渠道">
                <a-select
                  show-search
                  placeholder="请选择渠道"
                  option-filter-prop="children"
                  style="width: 200px"
                  :filter-option="filterOption"
                  :default-value="wechatApp[0]"
                  @change="handleChange"
                  id="aa"
                >
                  <a-select-option
                    v-for="item in wechatApp"
                    :key="item.appId"
                    :value="item.appId"
                    >{{ item.name }}</a-select-option
                  >
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 查询区域-END -->
      <a-tabs v-model="activeKey" @tab-click="handleTabClick">
        <a-tab-pane tab="图片素材" key="1" lazy>
          <material-file
            fileType="image"
            ref="imagePanel"
            @change="materialCount"
          ></material-file>
        </a-tab-pane>
      </a-tabs>
    </div>
  </a-card>
</template>
<script>
import { getAction } from '@/api/manage';
export default {
  data() {
    return {
      activeKey: '1',
      queryParam: {},
      imageBatch: [],
      assetsCount: {
        imageCount: '..',
        videoCount: '..',
        voiceCount: '..',
        newsCount: '..'
      },
      wechatApp: []
    };
  },
  components: {
    MaterialFile: () => import('./material-file')
  },
  mounted() {
    this.getWechatApp();
  },
  methods: {
    handleChange(value) {
      this.queryParam.appid = value;
      this.materialCount();
      console.log(this.queryParam.appid);
      this.$refs.imagePanel.getFileBatch(this.queryParam.appid);
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleTabClick(tab, event) {
      this.$nextTick(() => {
        this.$refs[tab.name + 'Panel'].init();
      });
    },
    getWechatApp() {
      getAction(process.env.VUE_APP_CMS_WECHAT + '/wechatApp/queryByType', {
        type: '1,2'
      }).then(res => {
        if (res.success) {
          this.wechatApp = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    materialCount() {
      getAction(
        process.env.VUE_APP_CMS_WECHAT + `/wechat/material/materialCount`,
        { appId: this.queryParam.appid }
      ).then(res => {
        if (res.success && res.code == 200) {
          this.assetsCount = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    }
  }
};
</script>
